export function parseLogoutTime(value) {
  if (!value) value = '4m'; // default
  const match = /^(\d+)([mhdw])$/i.exec(value.trim());
  if (!match) return 4 * 60 * 1000; // default 4 min

  const num = parseInt(match[1]);
  const unit = match[2].toLowerCase();

  const multipliers = {
    m: 60 * 1000,
    h: 60 * 60 * 1000,
    d: 24 * 60 * 60 * 1000,
    w: 7 * 24 * 60 * 60 * 1000,
  };

  return num * multipliers[unit] || 4 * 60 * 1000;
}
